import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const BookingPagination = ({ 
  paginationInfo, 
  handlePageChange
}) => {
  const { page_number, page_total, results_total } = paginationInfo;
  
  // Don't render if there's only one page or no results
  if (page_total <= 1 || results_total === 0) {
    return null;
  }

  return (
    <Box 
      sx={{ 
        marginTop: 2, 
        display: 'flex', 
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        marginBottom: 2
      }}
    >
      <IconButton
        onClick={() => handlePageChange(page_number - 1)}
        disabled={page_number <= 1}
        size="small"
        sx={{ 
          color: page_number <= 1 ? 'text.disabled' : 'text.primary',
          '&:hover': {
            backgroundColor: 'action.hover'
          }
        }}
      >
        <ChevronLeftIcon />
      </IconButton>

      <Typography 
        variant="body2" 
        sx={{ 
          mx: 2,
          minWidth: '80px',
          textAlign: 'center',
          color: 'text.secondary'
        }}
      >
        {page_number} / {page_total}
      </Typography>

      <IconButton
        onClick={() => handlePageChange(page_number + 1)}
        disabled={page_number >= page_total}
        size="small"
        sx={{ 
          color: page_number >= page_total ? 'text.disabled' : 'text.primary',
          '&:hover': {
            backgroundColor: 'action.hover'
          }
        }}
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
};

export default BookingPagination;